<div class="prs-auth-modal-panel" data-testing-id="demo-erp-modal">
  <div class="modal-header">
    <h2 class="modal-title" id="prs-auth-modal-demo-erp-title">
      {{ 'account.request_access.demo.title' | translate }}
    </h2>
    <button
      type="button"
      class="btn-close"
      [attr.title]="'dialog.close.text' | translate"
      [attr.aria-label]="'dialog.close.text' | translate"
      (click)="hide()"
    ></button>
  </div>

  <div class="modal-body">
    <p class="text-muted mb-3">{{ 'account.request_access.demo.hint' | translate }}</p>

    <div class="prs-auth-demo-picker" role="list">
      @for (account of accounts; track account.id) {
      <button
        type="button"
        class="prs-auth-demo__fill"
        role="listitem"
        (click)="select(account)"
        [attr.aria-label]="account.fillAriaKey | translate"
        [attr.data-testing-id]="'demo-erp-' + account.id"
      >
        <span class="prs-auth-demo__fill-label" aria-hidden="true">{{ account.labelKey | translate }}</span>
        <span class="prs-auth-demo__fill-creds" aria-hidden="true">
          <code>{{ account.erpCustomerNo }}</code>
          @if (account.companyName) {
          <span> — {{ account.companyName }}</span>
          }
        </span>
        <span class="prs-auth-demo__fill-outcome text-muted" aria-hidden="true">{{
          account.outcomeKey | translate
        }}</span>
      </button>
      }
    </div>
  </div>
</div>
